import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DossierCommentsSheetComponent } from '@sc/ui-components';
import {
  DossierCommentsInputData,
  DossierCommentsOutputData,
} from '@sc/data-access-models';
@Component({
  selector: 'sc-dossier-comments-dialog',
  styleUrls: ['./dossier-comments-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [DossierCommentsSheetComponent],
  template: `
    <sc-dossier-comments-sheet
      [dossierComments]="data.dossierComments"
      (dossierCommentResult)="onDossierCommentResult($event)"
    ></sc-dossier-comments-sheet>
  `,
})
export class DossierCommentsDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DossierCommentsInputData,
    private readonly dialogRef: MatDialogRef<
      DossierCommentsDialogComponent,
      DossierCommentsOutputData
    >
  ) {}

  onDossierCommentResult($event) {
    this.dialogRef.close($event);
  }
}
